import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export const UniqueValueValidator = (forms: FormArray, controlName: string): ValidatorFn => {
  return (activeControl: AbstractControl): ValidationErrors | null => {
    let valueExists = false;

    if (activeControl.value && forms.controls.length > 1) {
      forms.controls.forEach(form => {
        const compareControl = form.get(controlName);
        if (
          compareControl &&
          compareControl.value &&
          activeControl !== form.get(controlName) &&
          compareControl.value.trim().toUpperCase() === activeControl.value.trim().toUpperCase()
        ) {
          valueExists = true;
          activeControl.markAsTouched();
        }
      });
    }

    return valueExists ? { uniqueRequired: activeControl.value } : null;
  };
};

export const UniqueValueValidatorForms = (forms: FormArray): ValidatorFn => {
  return (activeControl: AbstractControl): ValidationErrors | null => {
    let valueExists = false;

    if (activeControl.value && forms && forms.controls.length > 1) {
      forms.controls.forEach(formControl => {
        if (activeControl == formControl) {
          return;
        }
        const compareValue = formControl.value;
        if (
          compareValue &&
          compareValue.trim().toUpperCase() === activeControl.value.trim().toUpperCase()
        ) {
          valueExists = true;
          activeControl.markAsTouched();
        }
      });
    }

    return valueExists ? { uniqueRequired: activeControl.value } : null;
  };
};
